<template>
  <a-layout class="index animated fadeIn s_bf">
    <a-card :bordered="false">
      <a-form
        :model="searchCp.data"
        :initialValues="searchCp.data"
        :onFinish="searchOnSubmit"
        layout="inline"
      >
        <a-form-item label="客户名称">
          <a-input
            style="width: 270px"
            v-model:value="searchCp.data.company_name"
            placeholder="请输入客户名称搜索"
          />
        </a-form-item>
        <a-form-item label="提交人">
          <a-input
            style="width: 270px"
            v-model:value="searchCp.data.create_user"
            placeholder="请输入提交人搜索"
          />
        </a-form-item>
        <a-form-item label="开户状态">
         <a-select v-model:value="searchCp.data.open_status" :style="{ width: '100px' }" placeholder="全部">
            <a-select-option value=""> 全部 </a-select-option>
            <a-select-option :value="1"> 待开户 </a-select-option>
            <a-select-option :value="2"> 已开户 </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType="submit" class="m-r-10"
            >搜索</a-button
          >
        </a-form-item>
      </a-form>
      <div class="m-t-25">
        <a-table
          :pagination="false"
          :loading="pageData.loading"
          bordered
          :rowKey="(record, index) => index"
          :columns="tableCp.columns"
          :data-source="pageData.data"
          class="tableFixBox"
          :scroll="{ x: 'max-content' }"
        >
          <template v-slot:action="{ record }">
            <a-button
              v-if="record.open_status == 1"
              type="primary"
              class="mx-5"
              v-has:brandAccountApplyForHandle="
                () => {
                  $router.push('/brand/accountApplyFor/handle?type=edit&id=' + record.id);
                }
              "
              >处理</a-button
            >
          </template>
        </a-table>
        <a-pagination
          :style="{ marginTop: '20px', textAlign: 'right' }"
          show-size-changer
          show-quick-jumper
          :current="pageData.page"
          :page-size="pageData.perPageCount"
          :total="pageData.total"
          @change="pageOnChange"
          @showSizeChange="pageSizeOnChange"
          :show-total="(total) => `总数: ${total} `"
        />
      </div>
    </a-card>
  </a-layout>
</template>
<script>
import {
  PlusOutlined,
  InboxOutlined,
  DeleteOutlined
} from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs, h } from "vue";
import { $iscode } from "@/utils/app";
import { getAccountApplyForList } from "@/api/brand.js";

export default {
  name: "accountApplyFor",
  components: {},
  setup(props, ctx) {
    const $route = inject("$route");
    const $Modal = inject("$Modal");
    const $message = inject("$message");
    const $loading = inject("$loading");
    const $store = inject("$store");

    /* 搜索 start */
    const searchCp = reactive({
      data: {
        company_name: "",
        create_user: "",
        status: 2,
        open_status: 1
      }
    });
    // 搜索提交
    const searchOnSubmit = (e) => {
      resetPageData();
      getPageData(gainParamData());
    };
    /* 搜索 end */

    /* 页面数据 start */
    let pageData = reactive({
      loading: false,
      // 当前第几页
      page: 1,
      // 每页数量，默认一页10条
      perPageCount: 10,
      // 总页数
      pageCount: 1,
      // 总条数，跟pageCount二选一就行
      total: 1,
      data: [{}],
      // 当前选中的
      currentData: {},
      // 页面其他请求loading，一般不是组件化控制时候才要，且只能同时只有一个才行
      loadingStatus: false
    });
    // 表单配置
    const tableCp = reactive({
      columns: [
        {
          title: "客户名称",
          dataIndex: "company_name",
          key: "company_name"
        },
        {
          title: "提交人",
          dataIndex: "create_user",
          key: "create_user"
        },
        {
          title: "提交时间",
          dataIndex: "create_time",
          key: "create_time"
        },
        {
          title: "开户状态",
          dataIndex: "open_status_text",
          key: "open_status_text"
        },

        {
          title: "操作",
          dataIndex: "action",
          key: "action",
          slots: { customRender: "action" }
        }
      ]
    });
    // 清空数据
    const emptyPageData = () => {
      pageData.data = [];
    };
    // 重置数据
    const resetPageData = () => {
      emptyPageData();
      pageData.loading = false;
      pageData.lock = false;
      pageData.page = 1;
    };
    // 获取页面数据
    const getPageData = async (paramData = {}) => {
      if (pageData.loading) {
        return;
      }
      pageData.loading = true;
      emptyPageData();
      let result = await getAccountApplyForList(paramData)
        .then((res) => res.data)
        .catch((error) => error);
      pageData.loading = false;
      if ($iscode(result, true, false)) {
        let respData = result.data || {};
        let respList = respData.data || [];

        pageData.data = respList || [];
        pageData.total = respData.total || 0;
      }
    };
    // 修改当前页
    const pageOnChange = (e) => {
      pageData.page = e;
      getPageData(gainParamData());
    };
    // 修改每页显示多少行
    const pageSizeOnChange = (currentPage, perPageCount) => {
      resetPageData();
      pageData.perPageCount = perPageCount;
      getPageData(gainParamData());
    };

    /* 页面数据 end */
    // 获取getPageData需要的数据
    const gainParamData = () => {
      // 转换搜索数据
      let searchData = {
        ...searchCp.data
      };
      // 转换分页数据
      let paginationData = {
        page: pageData.page,
        limit: pageData.perPageCount
      };
      return {
        ...searchData,
        ...paginationData
      };
    };

    onMounted(() => {
      if ($route.query.page) {
        pageData.page = $route.query.page;
      }
      getPageData(gainParamData());
    });

    return {
      // 搜索相关数据和操作
      searchCp,
      searchOnSubmit,
      // 页面相关数据和操作
      pageData,
      tableCp,
      pageOnChange,
      pageSizeOnChange
    };
  }
};
</script>
